import { useEffect } from 'react';
import { dropTargetForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { attachClosestEdge } from '@atlaskit/pragmatic-drag-and-drop-hitbox/closest-edge';

export function useGroupDropTarget(
  ref: React.RefObject<HTMLElement>,
  id: string,
  onDropGroup: (fromId: string, toId: string) => void
) {
  useEffect(() => {
    if (!ref.current) return;

    return dropTargetForElements({
      element: ref.current,
      getData: () => ({
        type: 'group',
        id,
      }),
      onDragEnter: ({ source, element }) => {
        if (!element || source.data?.type !== 'group') return;

        if (source.input && 'clientX' in source.input) {
          attachClosestEdge(element, {
            input: source.input,
            element,
            allowedEdges: ['top', 'bottom'],
          });
        }

        element.setAttribute('data-highlight', 'true');
      },

      onDragLeave: ({ element }) => {
        if (!element) return;
        element.removeAttribute('data-highlight');
        element.removeAttribute('data-edge');
      },
      onDrop: ({ source, target }) => {
        if (!source?.data || !target?.data) return;

        const fromId = source.data?.id;
        const toId = target.data?.id;

        if (fromId && toId && fromId !== toId) {
          onDropGroup(fromId, toId);
        }
      },
    });
  }, [ref, id, onDropGroup]);
}
